import { BaseCard, CardSection, ErrorCard } from "@fero/components";
import { useGetNominatedPurchasersForOrgQuery } from "@fero/hooks";
import { Skeleton, Typography } from "@mui/material";
import type React from "react";
import { createCurrencyFormatter } from "utils/currency-utils";

interface PurchaserCreditCardProps {
  nominatedPurchaserId: string;
}

export const PurchaserCreditCard: React.FC<PurchaserCreditCardProps> = (
  props,
) => {
  const { nominatedPurchaserId } = props;
  const {
    data: nominatedPurchasers = [],
    isLoading,
    isError,
  } = useGetNominatedPurchasersForOrgQuery();
  const nominatedPurchaser = nominatedPurchasers.find(
    (np) => np.nominatedPurchaserId === nominatedPurchaserId,
  );
  const currencyFormatter = createCurrencyFormatter(
    nominatedPurchaser?.currency ?? "GBP",
  );

  if (isLoading) {
    return <Skeleton variant="rounded" height={80} animation="wave" />;
  }

  if (isError) {
    return <ErrorCard message="Error loading credit info" />;
  }

  if (!nominatedPurchaser) {
    return (
      <BaseCard spacing={3}>
        <Typography variant="h6" fontWeight={500} fontSize={20}>
          Credit
        </Typography>
        <Typography>No credit details found for purchaser</Typography>
      </BaseCard>
    );
  }
  return (
    <BaseCard spacing={3}>
      <Typography variant="h6" fontWeight={500} fontSize={20}>
        Credit
      </Typography>

      <CardSection sectionTitle="Total Credit">
        <Typography>
          {currencyFormatter().format(Number(nominatedPurchaser.creditLimit))}
        </Typography>
      </CardSection>
      <CardSection sectionTitle="Credit Used">
        <Typography>
          {currencyFormatter().format(
            Number(nominatedPurchaser.creditLimit) -
              Number(nominatedPurchaser.availableCredit),
          )}
        </Typography>
      </CardSection>
      <CardSection sectionTitle="Credit Balance">
        <Typography>
          {currencyFormatter().format(
            Number(nominatedPurchaser.availableCredit),
          )}
        </Typography>
      </CardSection>
    </BaseCard>
  );
};
